import BookedSlotsComponent from "@components/routes/auth_routes/SlotsScreen/BookedSlotsComponent";

const CheckBookedSlotsComponent = () => {
  return (
    <div className="px-10 py-4 bg-white mt-4 rounded-md">
      <BookedSlotsComponent />
    </div>
  );
};

export default CheckBookedSlotsComponent;
